var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventLabLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 39,
    viewBox: "0 0 35 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2629_1125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 19.5C35.0001 17.4603 34.4238 15.4621 33.3375 13.7357C32.2512 12.0094 30.6992 10.6252 28.8604 9.74275V1.45854C28.8553 1.20359 28.7834 0.954435 28.652 0.735929C28.5206 0.517422 28.3341 0.3372 28.1113 0.213235C27.8885 0.0892713 27.6371 0.0258983 27.3821 0.0294374C27.1272 0.0329764 26.8776 0.103304 26.6583 0.233405L10.2083 10.7783H2.14375C1.86292 10.7764 1.58448 10.83 1.32447 10.9362C1.06447 11.0423 0.828024 11.1989 0.628766 11.3968C0.429507 11.5947 0.271368 11.8301 0.163457 12.0894C0.0555454 12.3487 -6.58697e-06 12.6268 5.85814e-10 12.9077L5.85813e-10 26.0341C-6.58697e-06 26.3149 0.0555454 26.593 0.163457 26.8523C0.271368 27.1116 0.429507 27.347 0.628766 27.545C0.828024 27.7429 1.06447 27.8994 1.32447 28.0056C1.58448 28.1117 1.86292 28.1654 2.14375 28.1635H10.2083L26.6 38.7083C26.8172 38.8374 27.0642 38.9078 27.3167 38.9127C27.5693 38.9176 27.8188 38.8567 28.0408 38.7362C28.2629 38.6156 28.4497 38.4394 28.5832 38.2249C28.7166 38.0104 28.7921 37.7648 28.8021 37.5124V29.199C30.6429 28.3292 32.201 26.9576 33.2973 25.242C34.3937 23.5263 34.9838 21.5361 35 19.5Z",
    fill: "#8CBE28"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2629_1125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventLabLogo);
export default __webpack_public_path__ + "static/media/eventLabLogo.2156ae95cde8d6ae28d9f85c1ee3fcbd.svg";
export { ForwardRef as ReactComponent };